import { withChartLayout } from 'components/common';
import CompletePhysicalAssessment from 'components/features/chart/system-assessment/complete-physical-assessment/CompletePhysicalAssessment';

const CompletePhysicalAssessmentPage = withChartLayout('Complete Physical Assessment - Narrative')(CompletePhysicalAssessment);
export default CompletePhysicalAssessmentPage;
